import React, { useState } from 'react';
import BottomSheet from '../components/BottomSheet';

const STEPS = [
  { n: 1, title: 'Redirection vers Google', text: 'Vous allez être redirigé vers la page de connexion Google.' },
  { n: 2, title: 'Sélection de votre fiche', text: 'Sélectionnez votre établissement Google Business Profile dans la liste.' },
  { n: 3, title: 'Autorisation Revyo', text: 'Autorisez Revyo à publier des réponses aux avis en votre nom.' },
];

export default function OAuthGmbSheet({ open, onClose, onContinue }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleContinue = async () => {
    setError(null);
    setLoading(true);
    try {
      await onContinue();
      // En cas de succès on ne ferme PAS la sheet : la navigation top-level vers Google
      // est en cours, le user quitte l'app.
    } catch (e) {
      setError(e.message || 'Impossible de démarrer la connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <BottomSheet open={open} onClose={loading ? undefined : onClose} title="Connecter Google Business" height="auto">
      <p style={styles.intro}>
        Connectez votre fiche Google Business Profile pour publier vos réponses aux avis directement depuis Revyo.
      </p>

      <ol style={styles.list}>
        {STEPS.map((s) => (
          <li key={s.n} style={styles.item}>
            <span style={styles.num}>{s.n}</span>
            <div style={styles.body}>
              <div style={styles.title}>{s.title}</div>
              <p style={styles.text}>{s.text}</p>
            </div>
          </li>
        ))}
      </ol>

      <button
        type="button"
        onClick={handleContinue}
        disabled={loading}
        style={{ ...styles.cta, opacity: loading ? 0.7 : 1 }}
      >
        {loading ? 'Préparation…' : 'Continuer vers Google'}
      </button>

      <p style={styles.hint}>Vous reviendrez automatiquement sur Revyo après la connexion.</p>

      {error && <div style={styles.error}>{error}</div>}
    </BottomSheet>
  );
}

const styles = {
  intro: {
    margin: '0 0 16px',
    fontSize: 14,
    color: '#1A1A1A',
    lineHeight: 1.5,
  },
  list: {
    margin: '0 0 20px',
    padding: 0,
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  item: {
    display: 'flex',
    gap: 12,
    background: '#FFFFFF',
    border: '1px solid #EDEAE3',
    borderRadius: 12,
    padding: 12,
  },
  num: {
    flexShrink: 0,
    width: 28,
    height: 28,
    borderRadius: '50%',
    background: '#FFF5F0',
    color: '#E8502A',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 14,
    fontWeight: 700,
  },
  body: { flex: 1, minWidth: 0 },
  title: { fontSize: 14, fontWeight: 700, color: '#1A1A1A' },
  text: { margin: '4px 0 0', fontSize: 13, color: '#6B6B6B', lineHeight: 1.4 },
  cta: {
    width: '100%',
    background: '#E8502A',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: 12,
    padding: '14px 16px',
    fontSize: 15,
    fontWeight: 700,
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  hint: {
    margin: '8px 0 0',
    fontSize: 12,
    color: '#6B6B6B',
    textAlign: 'center',
  },
  error: {
    marginTop: 12,
    background: '#FDEAE5',
    color: '#C8442A',
    fontSize: 13,
    padding: '10px 14px',
    borderRadius: 10,
  },
};
